const getBackendBaseURL = () => {
    const origin = window.location.origin;
  
    if (origin.includes("localhost")) {
      return "http://localhost:5000"; // Local Development
    } else if (origin.includes("staging2")) {
      return "https://staging2.aseetsoft.com"; // Staging Environment
    } else if (origin.includes("staging")) {
      return "https://staging.aseetsoft.com"; // Staging Environment
    } else if (origin.includes("new.aseetsoft.com")){
      return "https://new.aseetsoft.com";
    } else {
      return "https://aseetsoft.com"; // Production Environment
    }
  };
  
  const CONFIG = {
    BASE_URL: getBackendBaseURL(),
//    HTTP_PROTOCOL: window.location.protocol,
//    DOMAIN_NAME: window.location.hostname,
  };
  
  export default CONFIG;
  